import {combineReducers} from "redux";
import Auth from "./slice/auth";
import customerAccount from "./slice/customerAccount";
import customerLedgerMemo from "./slice/customerLedgerMemo";
import customerLedger from "./slice/customerLedger";
import table from "./slice/component/table";
import Default from "./slice/default";

export default combineReducers({
    default: Default,
    //Component,
    component_table: table,
    //System,
    auth: Auth,
    customerAccount: customerAccount,
    customerLedgerMemo: customerLedgerMemo,
    customerLedger: customerLedger
});
